import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useCallback } from '@redneckz/uni-jsx/lib/hooks';
import { useIntersectionObserver, } from '../../hooks/useIntersectionObserver.js';
import { TopItem } from '../../ui-kit/TopItem/TopItem.js';
export const HeaderTopMenuItem = JSX(({ observerOptions, onVisibilityChange, children, className, ...rest }) => {
    const observerCallback = useCallback((entries) => {
        if (!entries.length || !onVisibilityChange) {
            return;
        }
        // Assumption about entries order (by time)
        const entry = entries[entries.length - 1];
        onVisibilityChange(entry.isIntersecting);
    }, [onVisibilityChange]);
    const ref = useIntersectionObserver(observerCallback, observerOptions);
    return (_jsx("span", { ref: ref, className: className, role: "menuitem", children: _jsx(TopItem, { ...rest, children: children }) }));
});
//# sourceMappingURL=HeaderTopMenuItem.js.map